import { capitalize } from 'lodash'
import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

class OverallScoreSlide {
    id = uuidv4()

    kind = 'OverallScoreSlide'

    @observable comparisonSurveyIds

    constructor({
        comparisonSurveyIds = [],
    }) {
        this.comparisonSurveyIds = comparisonSurveyIds
        this.hasComparisons = comparisonSurveyIds.length > 0
    }

    arrayOrUndefined = (arr) => (
        Array.isArray(arr) && arr.length > 0
            ? arr.filter(({ checked }) => checked).map(({ value }) => capitalize(value))
            : undefined
    )

    toJSON() {
        return {
            kind: this.kind,
            comparisonSurveyIds: this.arrayOrUndefined(this.comparisonSurveyIds.slice()),
        }
    }
}

export default OverallScoreSlide
